module.exports = __webpack_public_path__ + "img/child-org.f1036045.svg";